<template>
  <div class="col">
    <label for="startDateEl" class="form-label" style="font-size: 0.8rem">일자</label>
    <input ref="startDateElRef" name="startDateEl" id="startDateEl" class="form-control" type="date"
           @change="handleChange($event, 'startDate')"
           v-model="selectedStartDate"
           :min="getMinSearchDate()"
           :max="getMaxSearchDate()" />
  </div>
  <div class="col search-time-col" style="margin-left: -20px" v-show="props.hideTime !== true">
    <label for="startTimeEl" class="form-label" style="font-size: 0.8rem">시간</label>
    <select name="startTimeEl" id="startTimeEl" class="form-control search-date"
            @change="handleChange($event, 'startTime')"
            v-model="selectedStartTime">
      <option v-for="hour in timeList" :value="hour" :key="hour">{{ hour }} 시</option>
    </select>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {searchBarProps} from "@/store/searchbar";
import {changeFormat, getMaxSearchDate, getMinSearchDate} from "@/components/tacho/common/CommonFunc";
import dayjs from "dayjs";

const emit = defineEmits([]);
const props = defineProps({
  hideTime: Boolean,
})
const store = useStore();
const patchSearchBar = (data) => store.dispatch('patchSearchBar', data);

// 변수
const selectedStartIso = computed(() => store.state.searchBar.selectedStartIso);
const selectedStartDate = ref(changeFormat(store.state.searchBar.selectedStartIso, 'YYYY-MM-DD'));
const selectedStartTime = ref(changeFormat(store.state.searchBar.selectedStartIso, 'HH'));
const startDateElRef = ref(null);
const timeList = computed(() => store.state.searchBar.timeList);

// Methods
async function handleChange(evt, prop) {
  switch (prop) {
    case 'startDate': {
      if (evt.target.value.length !== 10) {
        return;
      }

      const startJS = dayjs(`${evt.target.value}T${selectedStartTime.value}:00:00`);
      await patchSearchBar({
        prop: searchBarProps.selectedStartIso,
        value: startJS.format('YYYY-MM-DDTHH:mm:ss'),
        evt,
      });
      break;
    }
    case 'startTime': {
      const startJS = dayjs(`${selectedStartDate.value}T${evt.target.value}:00:00`);
      await patchSearchBar({
        prop: searchBarProps.selectedStartIso,
        value: startJS.format('YYYY-MM-DDTHH:mm:ss'),
        evt,
      });
      break;
    }
  }
}

watch(
    selectedStartIso,
    (after, _) => {
      selectedStartDate.value = changeFormat(after, 'YYYY-MM-DD');
      selectedStartTime.value = changeFormat(after, 'HH');
    }
);
</script>

<style scoped>
</style>
